module.exports = __webpack_public_path__ + "home-partner-image-cloud.3d3ty1zZ.svg";